import React, {Component} from "react";
import {Link} from 'react-router-dom';

export default () => (
    <div className="menu-content-payer-data menu-content-item tab-parent screen-bottom-block">
        <div className="rounded-white-block">
            <ul className="tab-content profile-info items-list tab-content1 active">
                <li className="list-item">
                    <div className="balance-state" style={{marginBottom:"30px"}}>
                        <h3 style={{width:"100%", fontSize:"1.7rem"}}>Вы не являетесь юридическим лицом.</h3>
                    </div>
                    <div className="my-balance-actions">
                        <Link to={`/account/entity/create`} className="big-button button-action violet-button-gradient">
                            <button style={{width:'auto'}}>Зарегистрировать компанию</button>
                        </Link>
                    </div>
                </li>
            </ul>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/Account/CreateCompanyMessage.js